import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueParallaxJs from 'vue-parallax-js'
import i18n from './i18n'
import { SetLocalePlugin } from './i18n'

Vue.use(VueParallaxJs)
Vue.use(SetLocalePlugin)

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
